var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Button, CardContent } from 'material-ui';
import { connect } from 'react-redux';
import { sendUpdateMessage } from '../../websocket';
import { CustomCardHeader } from '../CustomCardHeader';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import { Remove, Add } from 'material-ui-icons';
var EMPTY_EXCHANGE = {
    alighting: 0,
    boarding: 0,
};
var EMPTY_EXCHANGE_MESSAGE = {
    children: EMPTY_EXCHANGE,
    adults: EMPTY_EXCHANGE,
    strollers: EMPTY_EXCHANGE,
    wheelchairs: EMPTY_EXCHANGE,
    other: EMPTY_EXCHANGE,
};
export var BUTTON_STYLE = {
    width: 48,
    minWidth: 48,
    height: 48,
    margin: 5,
};
var Passengers = /** @class */ (function (_super) {
    __extends(Passengers, _super);
    function Passengers(p) {
        var _this = _super.call(this, p) || this;
        _this.sendBoarding = function () {
            var message = {
                adults: { boarding: 1, alighting: 0 },
                children: EMPTY_EXCHANGE,
                strollers: EMPTY_EXCHANGE,
                wheelchairs: EMPTY_EXCHANGE,
                other: EMPTY_EXCHANGE,
            };
            _this.props.dispatch(sendUpdateMessage('passengerExchange', message));
            _this.setState(EMPTY_EXCHANGE_MESSAGE);
        };
        _this.sendAlight = function () {
            var message = {
                adults: { boarding: 0, alighting: 1 },
                children: EMPTY_EXCHANGE,
                strollers: EMPTY_EXCHANGE,
                wheelchairs: EMPTY_EXCHANGE,
                other: EMPTY_EXCHANGE,
            };
            _this.props.dispatch(sendUpdateMessage('passengerExchange', message));
            _this.setState(EMPTY_EXCHANGE_MESSAGE);
        };
        _this.state = EMPTY_EXCHANGE_MESSAGE;
        return _this;
    }
    Passengers.prototype.render = function () {
        var currentValue = this.props.value;
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomCardHeader, null, "Passengers"),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, justify: "space-around", alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { style: BUTTON_STYLE, variant: "raised", color: "primary", size: "small", onClick: this.sendAlight },
                            React.createElement(Remove, null))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body1" },
                            "Onboard: ",
                            React.createElement("strong", null, currentValue.adults))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { style: BUTTON_STYLE, variant: "raised", color: "primary", size: "small", onClick: this.sendBoarding },
                            React.createElement(Add, null)))))));
    };
    return Passengers;
}(React.Component));
export default connect(function (state) { return ({ value: state.passengers }); })(Passengers);



//////////////////
// WEBPACK FOOTER
// ./src/components/Passengers/index.tsx
// module id = 1700
// module chunks = 0